module.exports = __webpack_public_path__ + "static/photo_16-e092ccc34bcbf43df650fc89d65d209f.jpg";